/*
  Fotoupload im TeeInBlue-Personalisierer
  --------------------------------------------------------------------------
  Zwei Aufgaben:

  1. WARTEFLAECHE. Zwischen "Zuschneiden bestaetigt" und "Ergebnis sichtbar"
     liegen bei KI-Produkten regelmaessig 20-40 Sekunden. TeeInBlue zeigt in
     dieser Zeit nur eine Prozentzahl in einer Kachel. Hier legt sich stattdessen
     eine Flaeche mit laufendem Hund, zwei benannten Phasen, Fortschritt und
     wechselnden Saetzen darueber.

  2. KACHELREIHE. TeeInBlue hebt bis zu fuenf verarbeitete Fotos auf, um
     KI-Guthaben zu sparen, zeigt sie aber als 48px-Kaecheln ohne erkennbare
     Auswahl. Hier bekommen sie Daumennagelgroesse, die aktive Kachel einen
     Ring mit Haken, und daneben steht eine eigene Kachel zum Hinzufuegen.

  NICHT angefasst werden: Formularfelder, deren Namen und Werte, die
  Varianten-Auswahl und alles, was in den Warenkorb geht. Dieses Skript liest
  den DOM, setzt Klassen/Attribute und haengt eigene Knoten an - es klickt
  nichts an und schreibt in keine Eingabe.

  Texte: assets/paws-texte.js (pawsText / pawsTextListe).
  Styling: assets/tib-photo-upload.css.
*/
(function () {
  'use strict';

  if (window.__pawsPhotoUploadInit) return;
  window.__pawsPhotoUploadInit = true;

  var PHOTO_SEL = '.tee-field--photo .tee-photo';
  var THROTTLE_MS = 160;
  var TICK_MS = 250;
  /* Nach dieser Zeit gibt die Warteflaeche auf und zeigt wieder das Formular.
     Lieber ein Kunde, der die Kachel sieht, als einer, der vor einer
     Endlosanimation sitzt. */
  var HARTE_GRENZE_MS = 90000;
  var LANGSAM_AB_MS = 25000;

  /* Die Szenen zeichnen den Weg eines gemalten Bildes nach: anruehren,
     mischen, malen, vermessen. Der Satz unter der Buehne wechselt mit der
     Szene - zwei Rhythmen nebeneinander wirken unruhig.

     Die Reihe haengt an der Uhr, nicht am Fortschritt. Die Kopplung an den
     Prozentwert klang richtig, war in der Praxis aber unbrauchbar: der Wert
     der App springt, steht bei schnellem Upload sofort auf 100 und fehlt in
     der KI-Phase ganz. Dadurch fielen Szenen aus - das Lineal war ueber die
     gesamte Wartezeit nie zu sehen. Fester Takt heisst: nach einem Durchlauf
     hat der Kunde jede Szene einmal gesehen, danach beginnt es von vorn. */
  var SZENEN_REIHE = ['mix', 'palette', 'brush', 'measure'];
  var SZENE_MS = 10000;
  /* Mindestverweildauer als Sperre gegen doppelte Wechsel innerhalb eines
     Takts - etwa wenn die Buehne waehrend eines Laufs neu aufgebaut wird. */
  var SZENE_MIN_MS = 2600;
  var SATZ_LISTEN = {
    mix: 'photo_wait_lines_mix',
    palette: 'photo_wait_lines_palette',
    brush: 'photo_wait_lines_brush',
    measure: 'photo_wait_lines_measure',
    /* Bleibt stehen, damit die Szene ueber einen Eintrag in SZENEN_REIHE
       zurueckgeholt werden kann. */
    frame: 'photo_wait_lines_frame'
  };

  /* Nur Produkte mit Bildeffekt sammeln mehrere Ergebnisse, zwischen denen
     eine Auswahl Sinn ergibt. TeeInBlue zeigt seine Historie trotzdem
     ueberall an (save_uploaded_photos ist shopweit) und verraet im DOM nicht,
     welches Feld einen Effekt hat. Der Schalter kommt deshalb aus Liquid,
     gesetzt ueber den Produkt-Tag "tib-foto-galerie". */
  var GALERIE_ERLAUBT = (function () {
    var s = document.querySelector('script[data-paws-galerie]');
    return !!s && s.getAttribute('data-paws-galerie') === '1';
  })();

  /* ------------------------------------------------------------------ */
  /* Helfer: erst pruefen, dann schreiben                                */
  /* ------------------------------------------------------------------ */
  function setClass(el, name, an) {
    if (!el) return;
    if (el.classList.contains(name) === !!an) return;
    el.classList.toggle(name, !!an);
  }
  function setAttr(el, name, wert) {
    if (!el) return;
    if (wert === null || wert === false) {
      if (el.hasAttribute(name)) el.removeAttribute(name);
      return;
    }
    var s = String(wert);
    if (el.getAttribute(name) === s) return;
    el.setAttribute(name, s);
  }
  function setText(el, wert) {
    if (!el) return;
    var s = String(wert == null ? '' : wert);
    if (el.textContent === s) return;
    el.textContent = s;
  }
  /* `prio` nur dort setzen, wo es sein muss: TeeInBlue gewinnt bei manchen
     Eigenschaften gegen jede Stylesheet-Regel, ein Inline-Stil mit Prioritaet
     setzt sich dagegen durch. Siehe warteHoeheSetzen(). */
  function setStyle(el, prop, wert, prio) {
    if (!el) return;
    if (wert === null) {
      if (el.style.getPropertyValue(prop)) el.style.removeProperty(prop);
      return;
    }
    if (el.style.getPropertyValue(prop) === wert &&
        el.style.getPropertyPriority(prop) === (prio || '')) return;
    el.style.setProperty(prop, wert, prio || '');
  }
  function text(schluessel, werte) {
    return typeof window.pawsText === 'function' ? window.pawsText(schluessel, werte) : '';
  }
  function liste(schluessel) {
    return typeof window.pawsTextListe === 'function' ? window.pawsTextListe(schluessel) : [];
  }
  function sichtbar(el) {
    return !!(el && el.offsetParent !== null);
  }

  /* Vergleichsschluessel fuer Bild-Adressen: TeeInBlue haengt je nach Stelle
     unterschiedliche Groessen-/Cache-Parameter an dieselbe Datei. */
  function bildSchluessel(el) {
    if (!el) return '';
    var roh = el.currentSrc || el.getAttribute('src') || '';
    if (!roh) return '';
    var ohneQuery = roh.split('?')[0].split('#')[0];
    var teile = ohneQuery.split('/');
    return teile[teile.length - 1] || ohneQuery;
  }

  /* Ohne diese Ereignisse laesst sich nicht beantworten, wie viele Kunden am
     Foto scheitern - die Fehler meldet TeeInBlue nur an den eigenen Server. */
  var versuche = 0;
  function melden(name, nutzlast) {
    try {
      if (!window.pawsInsights || !window.pawsInsights.track) return;
      nutzlast = nutzlast || {};
      nutzlast.configurator = 'teeinblue';
      nutzlast.photo_attempt = versuche;
      window.pawsInsights.track(name, nutzlast);
    } catch (e) {
      /* Tracking darf den Upload niemals stoppen. */
    }
  }

  /* Aus "… : UPLOAD_UNKNOWN_ERROR" wird UPLOAD_UNKNOWN_ERROR. Ohne den Code
     ist eine Fehlermeldung im Bericht nicht auswertbar. */
  function fehlerCode(meldung) {
    if (!meldung) return 'unbekannt';
    var treffer = /([A-Z][A-Z0-9_]{5,})/.exec(meldung);
    return treffer ? treffer[1] : meldung.slice(0, 60);
  }

  /* ------------------------------------------------------------------ */
  /* Bausteine                                                           */
  /* ------------------------------------------------------------------ */
  var HAKEN_SVG =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
    '<path d="M7.6 14.2 3.9 10.5l1.4-1.4 2.3 2.3 6.8-6.8 1.4 1.4z" fill="currentColor"/></svg>';

  /* Werkzeug im Icon-Stil: kraeftige Silhouette, dunkle Kontur, wenige
     Farbflaechen. Auf 20 Pixeln Breite ist das der einzige Stil, der noch
     erkennbar bleibt - feine Verlaeufe und duenne Griffe verschwimmen dort zu
     einem Strich. Kontur, Holzton und Zwinge sind bei Pinsel, Topf, Palette
     und Lineal dieselben, damit die Requisiten wie ein Set wirken.
     Der Pinsel: dicker Stiel, rote Zwinge, tropfenfoermiges Borstenbuendel.
     Die Borsten tragen die gerade geladene Farbe (--paws-borste) - so sieht
     man, welche Farbe im naechsten Strich landet. */
  var PINSEL_SVG =
    '<svg viewBox="0 0 34 92" aria-hidden="true" focusable="false">' +
    '<g stroke="#2a211c" stroke-width="3" stroke-linejoin="round" stroke-linecap="round">' +
    '<path d="M17 3.6c2.9 0 5.3 2.4 5.3 5.3v42.2H11.7V8.9c0-2.9 2.4-5.3 5.3-5.3z" fill="#c48d84"/>' +
    '<path d="M10.3 51.1h13.4v11.8H10.3z" fill="#d9534f"/>' +
    '<path d="M23.5 62.9c4.1 5.7 6.3 11 6.3 15.9 0 7.4-5.7 12.2-12.8 12.2S4.2 86.2 4.2 78.8' +
    'c0-4.9 2.2-10.2 6.3-15.9z" fill="var(--paws-borste, #f5b54f)"/>' +
    '</g>' +
    /* Zwei Glanzkanten geben der flachen Form Rundung, ohne einen Verlauf zu
       brauchen - Verlaeufe kosten in einer Dauerschleife spuerbar mehr. */
    '<path d="M14.4 8.4c.4-1.6 1.2-2.5 2.4-2.5v43.7h-2.4z" fill="#ffffff" opacity=".38"/>' +
    '<path d="M12.6 68.2c-1.8 3.8-2.7 7.3-2.7 10.6 0 4.1 1.9 7.3 5 9.1-4.7-1.1-7.7-4.7-7.7-9.1' +
    'c0-3.4 1.2-6.9 3.6-10.6z" fill="#ffffff" opacity=".32"/>' +
    '</svg>';

  /* Farbeimer mit Henkel. Die Farboberflaeche steckt als eigene Ellipse im
     SVG, damit die Ruehrwellen darauf liegen und nicht daneben. */
  var EIMER_SVG =
    '<svg viewBox="0 0 76 68" aria-hidden="true" focusable="false">' +
    '<path d="M14 20C14 8.5 24 3 38 3s24 5.5 24 17" stroke="#2a211c" stroke-width="3.4" ' +
    'fill="none" stroke-linecap="round"/>' +
    '<path d="M9.5 18h57l-6.4 42.8a6 6 0 0 1-5.9 5.2H21.8a6 6 0 0 1-5.9-5.2z" fill="#e3e8ee" ' +
    'stroke="#2a211c" stroke-width="3" stroke-linejoin="round"/>' +
    '<path d="M12.5 20.5h9l-3.4 43h-.2z" fill="#ffffff" opacity=".7"/>' +
    '<path d="M55 20.5h9l-6 40.3a5 5 0 0 1-3 3.7z" fill="#2a211c" opacity=".1"/>' +
    '<ellipse cx="38" cy="18" rx="28.5" ry="7.6" fill="#c2cad3" stroke="#2a211c" stroke-width="3"/>' +
    '<ellipse class="paws-mix__farbe" cx="38" cy="19.2" rx="24.5" ry="6" ' +
    'fill="var(--paws-topf, #e8a33d)"/>' +
    '<ellipse class="paws-mix__welle paws-mix__welle--a" cx="38" cy="19.2" rx="9" ry="2.4" ' +
    'fill="none" stroke="#ffffff" stroke-width="1.5" opacity=".55"/>' +
    '<ellipse class="paws-mix__welle paws-mix__welle--b" cx="38" cy="19.2" rx="15" ry="3.8" ' +
    'fill="none" stroke="#ffffff" stroke-width="1.3" opacity=".38"/>' +
    '</svg>';

  /* Klassische Malerpalette mit Daumenloch. Die Farbnaepfe liegen als eigene
     Elemente darueber (siehe CSS), damit jeder einzeln aufploppen kann - im
     SVG waeren sie nur gemeinsam animierbar. */
  var PALETTE_SVG =
    '<svg viewBox="0 0 96 70" aria-hidden="true" focusable="false">' +
    '<path d="M45 3.4C21.8 3.4 4.2 17.6 4.2 35.8c0 12.4 9.1 22.1 20.2 22.1 6.2 0 8.2-3.4 12.5-3.4' +
    'c4.4 0 6.3 2.7 10.6 2.7 14.4 0 44.5-11.6 44.5-31.8C92 12.4 68.4 3.4 45 3.4z" ' +
    'fill="#dcae76" stroke="#2a211c" stroke-width="3.2" stroke-linejoin="round"/>' +
    /* Das Daumenloch bekommt denselben Ton wie die Buehne - ein Loch zeigt,
       was dahinter liegt, und genau das macht die Palette erkennbar. */
    '<ellipse cx="26.5" cy="43" rx="8.2" ry="6.6" fill="#efe7db" stroke="#2a211c" stroke-width="3"/>' +
    '<path d="M45 8.4C24.8 8.4 9.4 20 9.4 34.6c0 3 .6 5.8 1.8 8.3-2.4-3.4-3.8-7.4-3.8-11.8' +
    'C7.4 17.2 24 6 45 6c17.6 0 34.4 5.8 42.4 15.2C79 12.8 62.6 8.4 45 8.4z" ' +
    'fill="#ffffff" opacity=".38"/>' +
    '</svg>';

  /* Holzlineal fuer die Vermessungsszene. Die Skalenstriche entstehen in der
     Schleife - von Hand geschrieben waeren es zwanzig fast gleiche Zeilen. */
  var LINEAL_SVG = (function () {
    var striche = '';
    for (var i = 1; i < 24; i++) {
      var x = i * 5.4 + 3;
      var lang = i % 5 === 0;
      striche += '<path d="M' + x.toFixed(1) + ' 1.8v' + (lang ? '6.4' : '3.6') + '"/>';
    }
    return '<svg viewBox="0 0 136 18" aria-hidden="true" focusable="false">' +
      '<rect x="1.4" y="1.4" width="133.2" height="15.2" rx="3" fill="#f0d69a" ' +
      'stroke="#2a211c" stroke-width="2.6"/>' +
      '<g stroke="#7b6127" stroke-width="1.4" stroke-linecap="round">' + striche + '</g>' +
      '</svg>';
  })();


  /* ------------------------------------------------------------------ */
  /* Kachelreihe                                                         */
  /* ------------------------------------------------------------------ */
  /* Nach dem Loeschen des aktuellen Fotos steht das Feld leer da, obwohl in
     der Historie noch Bilder liegen - fuer den Kunden sieht das aus, als
     waere alles weg. Dann wird das erste Bild der Historie uebernommen.
     Streng begrenzt, damit daraus keine Schleife werden kann. */
  var hatteFoto = new WeakMap();
  var nachruecken = new WeakMap();
  var NACHRUECK_PAUSE_MS = 2500;
  var NACHRUECK_MAX = 3;

  function kachelnRendern(photo) {
    var head = photo.querySelector('.tee-photo-head');
    if (!head) return;

    var historie = photo.querySelector('.tee-photo-preview-history');
    var items = historie
      ? Array.prototype.slice.call(historie.querySelectorAll('.tee-photo-preview-history__item'))
      : [];
    var hauptLabel = photo.querySelector('.tee-photo-label');
    var hauptBild = photo.querySelector('img.tee-photo-image');
    var hatFoto = !!hauptBild;

    /* Ohne Bildeffekt gibt es nur ein Foto - die Historie waere dort nur
       Ballast und wird per CSS ausgeblendet. */
    var modus = GALERIE_ERLAUBT && items.length > 0 ? 'gallery' : 'single';
    setAttr(photo, 'data-paws-mode', modus);

    if (hauptLabel) {
      var aktiv = hatFoto && modus === 'gallery';
      setClass(hauptLabel, 'paws-photo-active', aktiv);
      hakenSetzen(hauptLabel, aktiv);
      /* Nur wo es wirklich eine Auswahl gibt - bei einem einzigen Foto waere
         "Wird verwendet" eine Ansage ohne Gegenstueck. */
      setAttr(hauptLabel, 'aria-label', aktiv ? text('photo_gallery_active') : null);
    }

    /* --- Historie-Kacheln ------------------------------------------ */
    /* Kein eigener Doppelungs-Abgleich: TeeInBlue nimmt das gerade
       verwendete Bild selbst aus der Historie heraus. Ein Abgleich ueber den
       Dateinamen liess stattdessen echte, andere Fotos verschwinden. */
    items.forEach(function (item) {
      setClass(item, 'paws-photo-active', false);
      hakenSetzen(item, false);
      setAttr(item, 'role', 'button');
      setAttr(item, 'tabindex', '0');
      setAttr(item, 'aria-label', text('photo_gallery_use'));
    });

    if (modus === 'gallery') nachrueckenPruefen(photo, hatFoto, items);
    hatteFoto.set(photo, hatFoto);

    /* --- Kopfzeile ------------------------------------------------- */
    var bar = photo.querySelector(':scope > .paws-photo-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'paws-photo-bar';
      bar.innerHTML = '<span class="paws-photo-bar__title"></span><span class="paws-photo-bar__hint"></span>';
      photo.appendChild(bar);
    }
    var anzahl = items.length + (hatFoto ? 1 : 0);
    var titel = '';
    var hinweis = '';
    if (hatFoto && modus === 'gallery' && anzahl > 1) {
      titel = text('photo_gallery_title_many', { anzahl: anzahl });
      hinweis = text('photo_gallery_hint_many');
    } else if (hatFoto) {
      titel = text('photo_gallery_title_one');
      hinweis = text('photo_gallery_hint_one');
    }
    setText(bar.querySelector('.paws-photo-bar__title'), titel);
    setText(bar.querySelector('.paws-photo-bar__hint'), hinweis);
    setAttr(bar, 'hidden', hatFoto ? null : '');

    /* --- Kachel zum Hinzufuegen ------------------------------------ */
    var input = photo.querySelector('.tee-photo-input input[type="file"], input[type="file"]');
    var addKachel = photo.querySelector(':scope > .paws-photo-add');
    var brauchtAdd = !!(input && input.id && hatFoto && modus === 'gallery');
    if (brauchtAdd) {
      if (!addKachel) {
        addKachel = document.createElement('label');
        addKachel.className = 'paws-photo-add';
        addKachel.innerHTML =
          '<span class="paws-photo-add__plus" aria-hidden="true">+</span><span class="paws-photo-add__text"></span>';
        photo.appendChild(addKachel);
      }
      setAttr(addKachel, 'for', input.id);
      setText(addKachel.querySelector('.paws-photo-add__text'), text('photo_gallery_add'));
      setAttr(photo, 'data-paws-add', '1');
    } else {
      if (addKachel) addKachel.remove();
      setAttr(photo, 'data-paws-add', null);
    }

    tippsRendern(photo, hatFoto);
  }

  /* Bei KI-Produkten entscheidet die Fotoqualitaet ueber das Ergebnis. Die
     Hinweise stehen deshalb VOR der Auswahl, nicht als Fehlermeldung danach -
     und verschwinden, sobald ein Foto da ist. Ohne KI-Effekt gibt es nichts
     zu erklaeren: das Foto wird dort unveraendert gedruckt. */
  function tippsRendern(photo, hatFoto) {
    var tipps = photo.querySelector(':scope > .paws-photo-tipps');
    if (hatFoto || !GALERIE_ERLAUBT) {
      if (tipps) tipps.remove();
      return;
    }
    if (!tipps) {
      tipps = document.createElement('div');
      tipps.className = 'paws-photo-tipps';
      var zeilen = liste('photo_tips_lines');
      var html = '<p class="paws-photo-tipps__title"></p><ul class="paws-photo-tipps__list">';
      for (var i = 0; i < zeilen.length; i++) {
        html += '<li></li>';
      }
      html += '</ul><p class="paws-photo-tipps__meta"></p>';
      tipps.innerHTML = html;
      setText(tipps.querySelector('.paws-photo-tipps__title'), text('photo_tips_title'));
      var punkte = tipps.querySelectorAll('.paws-photo-tipps__list li');
      for (var k = 0; k < punkte.length; k++) setText(punkte[k], zeilen[k]);
      /* Die 30 Sekunden gelten nur fuer die KI-Umwandlung - beim Einzelfoto
         waere die Ansage schlicht falsch. */
      var meta = GALERIE_ERLAUBT
        ? text('photo_tips_time') + ' ' + text('photo_tips_privacy')
        : text('photo_tips_privacy');
      setText(tipps.querySelector('.paws-photo-tipps__meta'), meta);
      photo.appendChild(tipps);
    }
  }

  function hakenSetzen(kachel, an) {
    var vorhanden = kachel.querySelector(':scope > .paws-photo-check');
    if (an && !vorhanden) {
      var span = document.createElement('span');
      span.className = 'paws-photo-check';
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = HAKEN_SVG;
      kachel.appendChild(span);
    } else if (!an && vorhanden) {
      vorhanden.remove();
    }
  }

  /* Loescht der Kunde das aktuelle Foto, bleibt bei TeeInBlue ein leeres Feld
     zurueck - mit einer gut gefuellten Historie daneben. Das wirkt, als waere
     die Auswahl kaputt. Stattdessen rueckt das erste Bild der Historie nach.
     Der Klick geht an TeeInBlues eigenen Auswahl-Handler; wir schreiben also
     nichts selbst in die Konfiguration. */
  function nachrueckenPruefen(photo, hatFoto, items) {
    if (hatFoto || !items.length) return;
    if (hatteFoto.get(photo) !== true) return;

    var stand = nachruecken.get(photo) || { anzahl: 0, zuletzt: 0 };
    var jetzt = Date.now();
    if (stand.anzahl >= NACHRUECK_MAX || jetzt - stand.zuletzt < NACHRUECK_PAUSE_MS) return;
    nachruecken.set(photo, { anzahl: stand.anzahl + 1, zuletzt: jetzt });

    var ziel = items[0];
    window.setTimeout(function () {
      if (photo.querySelector('img.tee-photo-image')) return;
      if (!ziel.isConnected) return;
      ziel.click();
    }, 0);
  }

  /* ------------------------------------------------------------------ */
  /* Warteflaeche                                                        */
  /* ------------------------------------------------------------------ */
  var laeufe = new WeakMap();

  function warteflaecheBauen(photo) {
    var flaeche = photo.querySelector(':scope > .paws-photo-wait');
    if (flaeche) return flaeche;
    flaeche = document.createElement('div');
    flaeche.className = 'paws-photo-wait';
    flaeche.setAttribute('role', 'status');
    flaeche.setAttribute('aria-live', 'polite');
    flaeche.hidden = true;
    flaeche.innerHTML =
      '<div class="paws-art" data-paws-szene="mix">' +
      /* Das Werkstueck: die leere Leinwand, an der gearbeitet wird. Sie zeigt
         bewusst NICHT das Kundenfoto - auf 146 Pixeln Breite bleibt davon nur
         Farbnebel, und ein Weichzeichner ueber dem eigenen Hund wirkt wie ein
         Fehler statt wie Fortschritt. Alle Szenen sind auf ihre Kanten
         ausgerichtet. */
      '<span class="paws-art__werk"><span class="paws-art__werk-bild"></span></span>' +

      '<div class="paws-art__szene paws-art__szene--mix">' +
      '<span class="paws-mix__eimer">' + EIMER_SVG + '</span>' +
      '<span class="paws-mix__spritzer paws-mix__spritzer--a"></span>' +
      '<span class="paws-mix__spritzer paws-mix__spritzer--b"></span>' +
      '</div>' +

      '<div class="paws-art__szene paws-art__szene--palette">' +
      '<span class="paws-palette__brett">' + PALETTE_SVG + '</span>' +
      '<span class="paws-palette__klecks paws-palette__klecks--a"></span>' +
      '<span class="paws-palette__klecks paws-palette__klecks--b"></span>' +
      '<span class="paws-palette__klecks paws-palette__klecks--c"></span>' +
      '<span class="paws-palette__misch"></span>' +
      '</div>' +

      /* Striche und Pinselbahnen teilen sich dieselben Koordinaten: das SVG
         ist genau 240x120 gross, eine Einheit im viewBox ist also ein Pixel
         auf der Buehne - die offset-path-Angaben im CSS nennen dieselben
         Punkte. pathLength="100" normiert jeden Pfad auf 100 Einheiten, so
         laeuft der Strich unabhaengig von seiner echten Laenge im gleichen
         Takt wie der Pinsel. Zwei Striche statt drei: gleichzeitige Bewegung
         wirkt hektisch, Ruhe wirkt teuer. */
      '<div class="paws-art__szene paws-art__szene--brush">' +
      '<svg class="paws-brush__leinwand" viewBox="0 0 240 120" ' +
      'aria-hidden="true" focusable="false">' +
      '<path class="paws-brush__strich paws-brush__strich--a" fill="none" stroke-linecap="round" ' +
      'pathLength="100" d="M62 42C88 28 116 54 144 41 164 32 178 37 186 47"/>' +
      '<path class="paws-brush__strich paws-brush__strich--b" fill="none" stroke-linecap="round" ' +
      'pathLength="100" d="M60 76C90 62 112 87 146 73 166 64 180 68 186 78"/>' +
      '</svg>' +
      '<span class="paws-brush__pinsel paws-brush__pinsel--b">' + PINSEL_SVG + '</span>' +
      '</div>' +

      '<div class="paws-art__szene paws-art__szene--measure">' +
      '<span class="paws-measure__raster"></span>' +
      '<svg class="paws-measure__linien" viewBox="0 0 240 120" ' +
      'aria-hidden="true" focusable="false">' +
      '<path class="paws-measure__mass paws-measure__mass--quer" pathLength="100" d="M46 112h148M46 107v10M194 107v10"/>' +
      '<path class="paws-measure__mass paws-measure__mass--hoch" pathLength="100" d="M34 16v88M29 16h10M29 104h10"/>' +
      '<path class="paws-measure__ecke paws-measure__ecke--a" pathLength="100" d="M56 26v-10h14"/>' +
      '<path class="paws-measure__ecke paws-measure__ecke--b" pathLength="100" d="M184 26v-10h-14"/>' +
      '</svg>' +
      '<span class="paws-measure__lineal">' + LINEAL_SVG + '</span>' +
      '</div>' +

      '<div class="paws-art__szene paws-art__szene--frame">' +
      '<span class="paws-frame__rahmen"></span>' +
      '<span class="paws-frame__glanz"></span>' +
      '</div>' +

      /* Ein Pinsel begleitet alle Szenen. Er steht ausserhalb der Szenen und
         faehrt beim Wechsel an seinen neuen Platz, statt mit der Szene zu
         verschwinden - das macht aus fuenf Bildern eine Geschichte. Aussen
         der Platzwechsel, innen die Arbeitsbewegung: beide brauchen
         `transform`, und zwei Regeln fuer dieselbe Eigenschaft an einem
         Element schliessen sich aus. */
      '<span class="paws-art__held"><span class="paws-art__held-inner">' + PINSEL_SVG + '</span></span>' +
      '</div>' +

      '<p class="paws-photo-wait__title"></p>' +
      '<div class="paws-photo-wait__bar"><span class="paws-photo-wait__fill"></span></div>' +
      '<span class="paws-photo-wait__pct"></span>' +
      '<p class="paws-photo-wait__line"></p>' +
      '<p class="paws-photo-wait__hint"></p>';
    photo.appendChild(flaeche);
    return flaeche;
  }

  function starten(photo) {
    var lauf = laeufe.get(photo);
    if (lauf && lauf.aktiv) return;
    var hauptBild = photo.querySelector('img.tee-photo-image');
    lauf = {
      aktiv: true,
      start: Date.now(),
      phase: 'upload',
      prozent: 0,
      szene: '',
      szeneZeit: 0,
      satzZaehler: -1,
      basisKey: bildSchluessel(hauptBild)
    };
    laeufe.set(photo, lauf);

    /* Die Buehne gehoert zur KI-Umwandlung. Ohne Effekt dauert der Upload
       wenige Sekunden - eine Wartegeschichte waere dort schlicht gelogen.
       Der Lauf selbst startet trotzdem, sonst faenden die Ereignisse zum
       Fotoupload nur auf der Haelfte der Produkte statt. */
    if (GALERIE_ERLAUBT) {
      var flaeche = warteflaecheBauen(photo);
      flaeche.hidden = false;
      setClass(flaeche, 'is-done', false);
      setClass(flaeche, 'is-offen', false);
      fortschrittSetzen(photo, flaeche, 0);
      setAttr(photo, 'data-paws-wait', '1');
      szeneSetzen(photo, lauf, 'mix', true);
      warteHoeheSetzen(photo, flaeche);
    }
    tickSicherstellen();
    versuche++;
    melden('configurator_photo_start', {});
  }

  function beenden(photo, mitErfolg) {
    var lauf = laeufe.get(photo);
    if (!lauf || !lauf.aktiv) return;
    lauf.aktiv = false;
    if (mitErfolg) {
      melden('configurator_photo_success', {
        photo_seconds: Math.round((Date.now() - lauf.start) / 100) / 10
      });
    }
    var flaeche = photo.querySelector(':scope > .paws-photo-wait');
    if (!flaeche) {
      setAttr(photo, 'data-paws-wait', null);
      setStyle(photo, 'min-height', null);
      return;
    }
    if (mitErfolg) {
      setClass(flaeche, 'is-offen', false);
      fortschrittSetzen(photo, flaeche, 100);
      setClass(flaeche, 'is-done', true);
      setText(flaeche.querySelector('.paws-photo-wait__title'), text('photo_wait_done'));
      setText(flaeche.querySelector('.paws-photo-wait__line'), '');
      setText(flaeche.querySelector('.paws-photo-wait__hint'), '');
      window.setTimeout(function () {
        flaeche.hidden = true;
        setAttr(photo, 'data-paws-wait', null);
        setStyle(photo, 'min-height', null);
      }, 900);
    } else {
      flaeche.hidden = true;
      setAttr(photo, 'data-paws-wait', null);
      setStyle(photo, 'min-height', null);
    }
  }

  /* Jede Szene bekommt dieselbe Zeit, die Reihe laeuft im Kreis. Gemessen ab
     Beginn der Wartezeit, nicht ab Beginn einer Phase: der Kunde erlebt einen
     Vorgang, keine zwei. */
  function szeneFuerZeit(lauf) {
    var schritt = Math.floor((Date.now() - lauf.start) / SZENE_MS);
    return SZENEN_REIHE[schritt % SZENEN_REIHE.length];
  }

  /* Jede Szene bringt ihre eigenen Saetze mit. Bild und Text muessen
     zusammenpassen - "Wir richten die Ohren aus" neben einem Farbeimer
     erzaehlt zwei verschiedene Geschichten. */
  function szeneSetzen(photo, lauf, szene, sofort) {
    var flaeche = photo.querySelector(':scope > .paws-photo-wait');
    if (!flaeche) return;
    if (SZENEN_REIHE.indexOf(szene) < 0) return;
    if (!sofort) {
      if (szene === lauf.szene) return;
      /* Mindestverweildauer: ein springender Prozentwert darf die Szene nicht
         mehrmals pro Sekunde umwerfen. */
      if (Date.now() - lauf.szeneZeit < SZENE_MIN_MS) return;
    }
    lauf.szene = szene;
    lauf.szeneZeit = Date.now();
    lauf.satzZaehler++;
    setAttr(flaeche.querySelector('.paws-art'), 'data-paws-szene', szene);

    var saetze = liste(SATZ_LISTEN[szene]);
    if (!saetze.length) return;
    var zeile = flaeche.querySelector('.paws-photo-wait__line');
    var neu = saetze[lauf.satzZaehler % saetze.length];
    if (sofort) {
      setText(zeile, neu);
      return;
    }
    setClass(zeile, 'is-out', true);
    window.setTimeout(function () {
      setText(zeile, neu);
      setClass(zeile, 'is-out', false);
    }, 320);
  }

  /* Der Fuellstand laeuft ueber eine Variable, nicht ueber ein Inline-`width`:
     die CSS-Regel steht mit `!important` im Stylesheet und schlaegt jeden
     Inline-Wert ohne Prioritaet - der Balken blieb dadurch auf 0 stehen. */
  function fortschrittSetzen(photo, flaeche, prozent) {
    var wert = Math.max(0, Math.min(100, Math.round(prozent)));
    setStyle(flaeche, '--paws-fill', wert + '%');
    setText(flaeche.querySelector('.paws-photo-wait__pct'), wert + ' %');
  }

  /* Hoehe der Kachel waehrend der Wartezeit.

     Warum aus dem Skript und nicht aus dem Stylesheet: TeeInBlue setzt auf
     `.tee-photo` eine eigene `min-height` (gemessen 276px), gegen die eine
     eigene Regel nichts ausrichtet - auch nicht mit gleicher Spezifitaet,
     `!important` und als zuletzt eingefuegtes <style> im <head>. Ein
     Inline-Stil mit Prioritaet gewinnt dagegen zuverlaessig.

     Warum gemessen und nicht fest: der Inhalt ist unterschiedlich hoch -
     die Prozentzahl laeuft nur waehrend der Uebertragung mit, und der
     Hinweis wird je nach Breite und Wartedauer ein- bis dreizeilig. Ein
     fester Wert waere entweder zu knapp (Buehne und Hinweis kleben an der
     Kante, genau die Beschwerde) oder in der Regel zu luftig.

     Kein Aufschaukeln moeglich: gemessen werden nur die Kinder der
     Warteflaeche. Deren Hoehe haengt an Schriftgroesse und Breite, nicht an
     der Hoehe, die hier gesetzt wird. Zusaetzlich harte Grenzen und ein
     Totband gegen Subpixel-Zittern. */
  var WARTE_LUFT = 24;
  var WARTE_MIN = 200;
  var WARTE_MAX = 520;

  function warteHoeheSetzen(photo, flaeche) {
    if (!photo || !flaeche || flaeche.hidden) return;
    var kinder = flaeche.children;
    var inhalt = 0;
    var sichtbare = 0;
    for (var i = 0; i < kinder.length; i++) {
      var h = kinder[i].getBoundingClientRect().height;
      if (!h) continue;
      inhalt += h;
      sichtbare++;
    }
    if (!sichtbare) return;
    var stil = window.getComputedStyle(flaeche);
    var abstand = parseFloat(stil.rowGap) || 0;
    var luft = parseFloat(stil.paddingTop);
    if (!(luft >= 0)) luft = WARTE_LUFT;
    /* Die Flaeche liegt im Innenmass der Kachel, die min-height zaehlt bis
       zur Aussenkante - der Rahmen kommt also oben drauf. Die Differenz ist
       genau die Rahmenbreite und damit unabhaengig von der Hoehe, die hier
       gesetzt wird; ein Aufschaukeln ist ausgeschlossen. */
    var rahmen = photo.getBoundingClientRect().height - flaeche.getBoundingClientRect().height;
    if (!(rahmen >= 0) || rahmen > 20) rahmen = 3;
    var soll = Math.round(inhalt + (sichtbare - 1) * abstand + 2 * luft + rahmen);
    soll = Math.max(WARTE_MIN, Math.min(WARTE_MAX, soll));
    var ist = parseFloat(photo.style.getPropertyValue('min-height')) || 0;
    if (Math.abs(soll - ist) < 2) return;
    setStyle(photo, 'min-height', soll + 'px', 'important');
  }

  /* TeeInBlues eigene Ladeanzeige liefert die einzigen echten Prozentwerte -
     aber nur fuer die Uebertragung, nicht fuer die KI-Phase danach. */
  function uploadProzent(photo) {
    var anzeige = photo.querySelector('.tee-photo-uploading');
    if (!anzeige) return null;
    var treffer = /(\d{1,3})\s*%/.exec(anzeige.textContent || '');
    return treffer ? Math.max(0, Math.min(100, parseInt(treffer[1], 10))) : 0;
  }

  function ergebnisDa(photo, lauf) {
    var bild = photo.querySelector('img.tee-photo-image');
    if (!bild) return false;
    if (!bild.complete || !bild.naturalWidth) return false;
    var key = bildSchluessel(bild);
    if (!key) return false;
    return key !== lauf.basisKey;
  }

  /* Der Zuschneide-Dialog der App liegt als eigenes Overlay ueber der Seite.
     Solange er offen ist, hat der Kunde noch gar nichts abgeschickt. */
  function dialogOffen() {
    var kandidaten = document.querySelectorAll('.vm--container, .vm--modal, .tee-modal');
    for (var i = 0; i < kandidaten.length; i++) {
      if (sichtbar(kandidaten[i])) return true;
    }
    return false;
  }

  /* Schlaegt der Upload fehl, schreibt die App die Meldung in .tee-photo-message.
     Ohne diese Pruefung wuerde die Warteflaeche bis zur harten Grenze weiter
     laufen - der Kunde saehe eine Animation, obwohl es nichts mehr zu warten
     gibt, und wuerde die Meldung nie zu Gesicht bekommen.
     Verglichen wird gegen den Stand beim Dateiwechsel: eine stehen gebliebene
     Meldung vom vorherigen Versuch darf den naechsten nicht blockieren. */
  var meldungBeimStart = new WeakMap();
  function meldungText(photo) {
    var m = photo.querySelector('.tee-photo-message');
    return m ? (m.textContent || '').trim() : '';
  }
  function fehlerGemeldet(photo) {
    var jetzt = meldungText(photo);
    if (!jetzt) return false;
    return jetzt !== (meldungBeimStart.get(photo) || '');
  }

  var tickId = null;
  var scharf = new WeakSet();

  function tickSicherstellen() {
    if (tickId !== null) return;
    tickId = window.setInterval(tick, TICK_MS);
  }

  function tick() {
    var photos = document.querySelectorAll(PHOTO_SEL);
    var nochWas = false;

    for (var i = 0; i < photos.length; i++) {
      var photo = photos[i];
      var lauf = laeufe.get(photo);
      var laedt = !!photo.querySelector('.tee-photo-uploading');

      /* Start: entweder zeigt die App bereits ihren Fortschritt, oder der
         Kunde hat eine Datei gewaehlt und den Zuschnitt bestaetigt. */
      if ((!lauf || !lauf.aktiv) && !fehlerGemeldet(photo) && (laedt || (scharf.has(photo) && !dialogOffen()))) {
        starten(photo);
        lauf = laeufe.get(photo);
      }
      if (!lauf || !lauf.aktiv) continue;
      nochWas = true;

      var flaeche = photo.querySelector(':scope > .paws-photo-wait');

      var alter = Date.now() - lauf.start;

      if (ergebnisDa(photo, lauf)) {
        scharf.delete(photo);
        beenden(photo, true);
        continue;
      }
      if (fehlerGemeldet(photo) || alter > HARTE_GRENZE_MS) {
        scharf.delete(photo);
        var dauer = Math.round(alter / 100) / 10;
        if (fehlerGemeldet(photo)) {
          melden('configurator_photo_error', {
            photo_seconds: dauer,
            photo_phase: lauf.phase,
            photo_error_code: fehlerCode(meldungText(photo))
          });
        } else {
          melden('configurator_photo_abort', {
            photo_seconds: dauer,
            photo_phase: lauf.phase,
            reason: 'zeitueberschreitung'
          });
        }
        beenden(photo, false);
        continue;
      }

      /* Solange TeeInBlue selbst zaehlt, wird GENAU dieser Wert gezeigt -
         zwei verschiedene Prozentzahlen fuer denselben Vorgang zerstoeren
         jedes Vertrauen in die Anzeige. Danach gibt es keinen echten Wert
         mehr; statt einen zu erfinden, laeuft ein Streifen durch. */
      var echt = uploadProzent(photo);
      lauf.phase = echt === null ? 'ai' : 'upload';
      if (echt !== null) lauf.prozent = echt;

      /* Ohne Buehne (Produkt ohne KI-Effekt) laeuft nur die Zustandsmaschine
         weiter - sie liefert die Ereignisse und die harte Zeitgrenze. */
      if (!flaeche) continue;

      setClass(flaeche, 'is-offen', echt === null);
      if (echt !== null) fortschrittSetzen(photo, flaeche, lauf.prozent);

      setText(
        flaeche.querySelector('.paws-photo-wait__title'),
        text(lauf.phase === 'upload' ? 'photo_wait_title_upload' : 'photo_wait_title_ai')
      );
      setText(
        flaeche.querySelector('.paws-photo-wait__hint'),
        text(alter > LANGSAM_AB_MS ? 'photo_wait_hint_slow' : 'photo_wait_hint')
      );

      szeneSetzen(photo, lauf, szeneFuerZeit(lauf), false);
      warteHoeheSetzen(photo, flaeche);
    }

    if (!nochWas && tickId !== null) {
      window.clearInterval(tickId);
      tickId = null;
    }
  }

  /* ------------------------------------------------------------------ */
  /* Anwenden + Beobachten                                               */
  /* ------------------------------------------------------------------ */
  var laeuft = false;
  var beobachter = null;
  var geplant = null;
  var fensterStart = 0;
  var fensterLaeufe = 0;
  var wachstumsZaehler = 0;
  var letzteHoehe = 0;
  var abgeschaltet = false;

  function sicherungAus(grund) {
    abgeschaltet = true;
    if (beobachter) { beobachter.disconnect(); beobachter = null; }
    if (window.console && console.warn) console.warn('[PawsFoto] Abgeschaltet: ' + grund);
  }

  function anwenden() {
    if (abgeschaltet || laeuft) return;
    var jetzt = Date.now();
    if (jetzt - fensterStart > 1000) { fensterStart = jetzt; fensterLaeufe = 0; }
    if (++fensterLaeufe > 12) { sicherungAus('zu viele Durchlaeufe pro Sekunde'); return; }

    /* Ein gedrosselter Durchlauf bleibt unter der Laufgrenze und kann die
       Seite trotzdem Stueck fuer Stueck aufblaehen - deshalb zusaetzlich
       das Dokument selbst im Blick behalten. */
    var hoehe = document.documentElement.scrollHeight;
    if (letzteHoehe && hoehe - letzteHoehe > 8) {
      if (++wachstumsZaehler >= 5) { sicherungAus('Seite waechst bei jedem Durchlauf'); return; }
    } else {
      wachstumsZaehler = 0;
    }
    letzteHoehe = hoehe;

    laeuft = true;
    try {
      var photos = document.querySelectorAll(PHOTO_SEL);
      for (var i = 0; i < photos.length; i++) {
        try { kachelnRendern(photos[i]); } catch (e) { /* ein defektes Feld darf die anderen nicht mitreissen */ }
      }
    } finally {
      /* Die eigenen Schreibvorgaenge sollen den Beobachter nicht erneut wecken. */
      if (beobachter) beobachter.takeRecords();
      laeuft = false;
    }
  }

  function planen() {
    if (abgeschaltet || geplant) return;
    geplant = window.setTimeout(function () {
      geplant = null;
      anwenden();
    }, THROTTLE_MS);
  }

  function beobachten() {
    var form = document.getElementById('teeinblue-form');
    if (!form || beobachter || abgeschaltet) return;
    beobachter = new MutationObserver(function () {
      if (laeuft) return;
      planen();
    });
    beobachter.observe(form, { childList: true, subtree: true });
  }

  function start() {
    if (!document.querySelector('#teeinblue-form')) return;
    anwenden();
    beobachten();

    /* Die App rendert die Felder nach dem ersten Laden noch mehrfach neu. */
    var versuche = 0;
    var anlauf = window.setInterval(function () {
      if (++versuche > 40 || abgeschaltet) { window.clearInterval(anlauf); return; }
      beobachten();
      anwenden();
    }, 300);
  }

  /* Ein "change" auf dem Datei-Feld ist der frueheste sichere Hinweis, dass
     ein Upload bevorsteht. Gezeigt wird die Flaeche aber erst, wenn der
     Zuschneide-Dialog wieder zu ist. */
  document.addEventListener(
    'change',
    function (ev) {
      var ziel = ev.target;
      if (!ziel || ziel.type !== 'file') return;
      var photo = ziel.closest ? ziel.closest('.tee-photo') : null;
      if (!photo) return;
      meldungBeimStart.set(photo, meldungText(photo));
      scharf.add(photo);
      tickSicherstellen();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  /* Zurueck-Navigation auf iOS/Android stellt die Seite aus dem Zwischenspeicher
     her, ohne DOMContentLoaded erneut auszuloesen. */
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) start();
  });

  /* Wer waehrend der Verarbeitung weggeht, ist der teuerste Abbruch ueberhaupt -
     er muss im Bericht von einem Fehler unterscheidbar sein. */
  window.addEventListener('pagehide', function () {
    try {
      var photos = document.querySelectorAll(PHOTO_SEL);
      for (var i = 0; i < photos.length; i++) {
        var lauf = laeufe.get(photos[i]);
        if (!lauf || !lauf.aktiv) continue;
        lauf.aktiv = false;
        melden('configurator_photo_abort', {
          photo_seconds: Math.round((Date.now() - lauf.start) / 100) / 10,
          photo_phase: lauf.phase,
          reason: 'seite_verlassen'
        });
      }
    } catch (e) {
      /* nichts */
    }
  });
}());
